import { Circle, Line, Vector2, Component, InputManager, UpdateContext } from "../Engine";
import { CornerMarks, Football, Goal, GoalZoneArea, HalfArea, PenaltyArea, SideLines, SoccerPlaygroundConfig, Sizes } from "./";

export class SoccerPlayground extends Component {
    bottomLeftCorner: Vector2 | undefined;
    topRightCorner: Vector2 | undefined;
    bottomRightCorner: Vector2 | undefined;
    
    //football: ImageDrawer | undefined;
    footballCursor: Football | undefined;

    sideLines: SideLines;
    upperPenaltyArea: PenaltyArea | undefined;    
    lowerPenaltyArea: PenaltyArea | undefined;
    
    upperGoalZoneArea: GoalZoneArea | undefined;
    lowerGoalZoneArea: GoalZoneArea | undefined;

    centerLine: Line | undefined;
    
    centerCircle: Circle | undefined;
    centerSpotCircle: Circle | undefined;
    centerPoint: Vector2 | undefined;

    upperGoal: Goal | undefined;
    lowerGoal: Goal | undefined;

    cornerMarks: CornerMarks | undefined;

    createdFootballs: Array<Football> = [];

    constructor(public config: SoccerPlaygroundConfig) {
        super();
       
        this.sideLines = new SideLines(config);
        this.children.push(this.sideLines);

        this.initialize();
    }
    
    initialize() {

        this.centerCircle = new Circle(this.config.centerPoint, this.config.conversionFactor * Sizes.DistanceRadius);
        this.centerSpotCircle = new Circle(this.config.centerPoint, 2, true);

        this.centerLine = new Line(
            new Vector2(this.config.topLeftCorner.x, this.config.topLeftCorner.y + this.config.height / 2), 
            new Vector2(this.config.topLeftCorner.x + this.config.width, this.config.topLeftCorner.y + this.config.height / 2));
        
        this.lowerPenaltyArea = new PenaltyArea(this.config, HalfArea.LowerArea);
        this.upperPenaltyArea = new PenaltyArea(this.config, HalfArea.UpperArea);

        this.upperGoalZoneArea = new GoalZoneArea(this.config, HalfArea.UpperArea);
        this.lowerGoalZoneArea = new GoalZoneArea(this.config, HalfArea.LowerArea);

        this.upperGoal = new Goal(this.config, HalfArea.UpperArea);
        this.lowerGoal = new Goal(this.config, HalfArea.LowerArea);

        this.cornerMarks = new CornerMarks(this.config);

        this.footballCursor = new Football(this.config, true);
        this.footballCursor.location = this.config.centerPoint;
        
        this.children.push(
            this.centerLine,
            this.centerCircle,
            this.centerSpotCircle,
            this.lowerPenaltyArea,        
            this.upperPenaltyArea,
            this.upperGoalZoneArea,
            this.lowerGoalZoneArea,
            this.upperGoal,
            this.lowerGoal,
            this.cornerMarks,
            this.footballCursor);
    }

    update(updateContext: UpdateContext): void {
        super.update(updateContext);

        if (InputManager.isMouseLeftClick()) {
            this.createFootball(InputManager.getMousePosition());
        }

        if (InputManager.isMouseRightClick()) {
            const football = this.createFootball(InputManager.getMousePosition());
            football.update(updateContext);
            football.shootOnGoal();
        }

        const footballsToRemove = this.createdFootballs.filter(f => 
               f.location.y < ((this.upperGoal?.leftPost?.y ?? 0) - (this.upperGoal?.height ?? 0))
            || f.location.y > ((this.lowerGoal?.leftPost?.y ?? 0) + (this.lowerGoal?.height ?? 0)));

        footballsToRemove.forEach(football => {
            this.children.splice(this.children.indexOf(football), 1);
            this.createdFootballs.splice(this.createdFootballs.indexOf(football), 1);
        });
    }

    draw(ctx: CanvasRenderingContext2D): void {
        ctx.lineWidth = 1.2;
        ctx.strokeStyle = 'white';

        const stripes = 38;
        const stripeHeight = this.config.height / stripes;
        for (let i = 0; i < stripes; i++){

            ctx.fillStyle = i % 2 === 0 ? 'rgb(0, 109, 59, 1)' : 'rgb(0, 119, 59, 1)';
            
            ctx.fillRect(this.config.topLeftCorner.x, this.config.topLeftCorner.y + i * stripeHeight, 
                this.config.width, stripeHeight);

        }

        super.draw(ctx);
    }

    private createFootball(location: Vector2) : Football {
        const football = new Football(this.config, false, true, location);
        this.children.push(football);
        this.createdFootballs.push(football);
        football.speed = this.config.footballSpeed;

        return football;
    }

    public reset() {
        
        this.createdFootballs.forEach(football => {
            this.children.splice(this.children.indexOf(football), 1);
        });
        this.createdFootballs = [];
        
    }
}